import { getPreviewLabels } from './helpers';

export const getReqSysRecommendedText = getPreviewLabels(
  'default-data.values.requirements.title.recommended'
);
export const getReqSysMinimumText = getPreviewLabels(
  'default-data.values.requirements.title.minimum'
);
